module.exports = "./assets/images/avatar-13.svg";